'use strict';

const isBrowser = typeof window !== "undefined";

exports.isBrowser = isBrowser;
//# sourceMappingURL=is-browser.cjs.map
